<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Report">
            <common-training-header/>
        </a-page-header>

      <a-card type="inner" size="small">
        <a-table
            class="pcp-table"
            :dataSource="items"
            :loading="loading"
            :pagination="false"
            rowKey="hash"
            bordered>

            <a-table-column :width="50" key="number" title="No" className="align-center text-small text-left">
                <h3 slot-scope="t,r,i" class="text-center">
                    {{ i + 1 }}
                </h3>
            </a-table-column>


            <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                <template slot-scope="record">
                    <div style="text-align: center">
                        <img :src="record.photo" v-if="record.photo != null" height="50" />
                        <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                    </div>
                </template>
            </a-table-column>

            <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                <template slot-scope="record">
                    {{ record.name }}
                </template>
            </a-table-column>

            <a-table-column key="gender" title="Gender" className="align-center text-small text-left">
                <template slot-scope="record">
                    <div v-if="record.gender != null">
                        {{ gender(record.gender) }}
                    </div>
                </template>
            </a-table-column>

            <a-table-column key="total" title="Total" className="align-center text-small text-center">
                <template slot-scope="record">
                    <a-button type="link" size="small" @click="viewReportDetail(record.hash)">
                        <strong> {{ parseFloat(record.score_data.total_score).toFixed(2) }}</strong>
                    </a-button>
                </template>
            </a-table-column>

            <a-table-column key="status" title="Status" className="align-center text-small text-center">
                <template slot-scope="record">
                    <div v-if="record.score_data.total_score != null">
                        <a-tag :color="record.wom.hex">
                            {{ record.wom.rating}}
                        </a-tag>
                    </div>
                </template>
            </a-table-column>
        </a-table>
      </a-card>
    </div>
</template>

<script>
export default {
    props: {
        training: {
            type: Object
        }
    },
    created() {
        this.getItems();
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            items: [],
        };
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.report.classical.highest_score'))
                .then(response => {
                  this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
        viewReportDetail(hash) {
            let params = {
                attendant: hash
            }
            window.location.href = this.routeUri('admin.classical.attendant.recap.score') + '?' + this.$qs.stringify(params)
        }
    }
};
</script>
